// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/

.CurrencyForm-checkBoxWidth-ECGRb {
	width: 24px;
	display: inline-block;
	vertical-align: top;
}

.CurrencyForm-textWidth-JhJt2 {
	width: 84%;
	vertical-align: middle;
	font-size: 16px;
	display: inline-block;
	margin-left: 5px;
	padding-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/SiteAdmin/Currency/CurrencyForm/CurrencyForm.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;CACC,WAAW;CACX,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,sBAAsB;CACtB,eAAe;CACf,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;AACnB","sourcesContent":["/** RentAll - Begin **/\n\n.checkBoxWidth {\n\twidth: 24px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n}\n\n.textWidth {\n\twidth: 84%;\n\tvertical-align: middle;\n\tfont-size: 16px;\n\tdisplay: inline-block;\n\tmargin-left: 5px;\n\tpadding-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkBoxWidth": `CurrencyForm-checkBoxWidth-ECGRb`,
	"textWidth": `CurrencyForm-textWidth-JhJt2`
};
module.exports = ___CSS_LOADER_EXPORT___;
